import client from '../httpClient';

const settingGroupStoreUpdateApi = (params) => {
  return client.put('/store-groups/settings', JSON.stringify(params));
};

export default settingGroupStoreUpdateApi;
